
import { useTranslation } from "react-i18next";
import errorFilledOrange from "../../assets/images/errorFilledOrange.svg";
import errorFilledRed from "../../assets/images/errorFilledRed.svg";
import flightUpIcon from "../../assets/images/flightUpIcon.svg";
import { SecondaryButton } from "../../common/Buttons";
import "./AlertBanner.scss";

export const AlertBanner = ({
    type,
    mainMessage,
    subMessage,
    className,
    onViewFlightClick,
}) => {
    const { t } = useTranslation(["labels"]);
    return (
        <div className={`alert-banner-container ${className || ""}`}>
            <div className="left-section">
                <div className="alert-content">
                    <img
                        src={type === "error" ? errorFilledRed : errorFilledOrange}
                        alt="alert-warn"
                        title={type === "error" ? "Error" : "Warning"}
                        className="alert-warn"
                    />
                    <label className="alert-main">{mainMessage}</label>
                </div>
                {subMessage && <label className="alert-sub">{subMessage}</label>}
            </div>
            <div className="right-section">
                <SecondaryButton
                    className="view-flight-btn"
                    label={
                        <>
                            <img
                                src={flightUpIcon}
                                alt="flight-up"
                            />
                            {t('BOOKING.VIEW_OTHER_FLIGHTS')}
                        </>
                    }
                    onClick={onViewFlightClick}
                />
            </div>
        </div>
    );
};
